import { Injectable } from '@angular/core';
import { DataService } from './../../../../Autofacets-Core/src/app/services/data.service';
import {CheckInDealerRequestModel, CheckInUserRequestModel, TraversalRequestModel} from '../business-entities/checkin-user-model';
import { GenericResponse } from '../../../../Autofacets-Core/src/app/business-entities/generic-response.class';
import { Urls } from './../../../../Autofacets-Core/src/app/utils/urls';
@Injectable({
    providedIn: 'root'
  })
export class CheckInUserDataService{
    constructor(private dataService: DataService) { }
    async getCheckInUserList(requestModel: CheckInUserRequestModel): Promise<GenericResponse<any>> {
        return this.dataService.Post<GenericResponse<any>>(Urls.GetCheckInUsageDealerList, requestModel).toPromise();
    }
    async getCheckInDealerList(requestModel: CheckInDealerRequestModel): Promise<GenericResponse<any>> {
        return this.dataService.Post<GenericResponse<any>>(Urls.GetCheckInUsageDealerWiseAppointmentList, requestModel).toPromise();
    }
    async GetCheckinTraversalList(requestModel: TraversalRequestModel): Promise<GenericResponse<any>> {
        return this.dataService.Post<GenericResponse<any>>(Urls.GetCheckinTraversalList, requestModel).toPromise();
    }
}